import 'lazysizes'
import 'wicg-inert'
import smoothscroll from 'smoothscroll-polyfill'
import cssVars from 'css-vars-ponyfill'

const updateSizing = () => {
    // We execute the same script as before
    const height = Math.min(
        document.documentElement.clientHeight,
        window.screen.height,
        window.innerHeight
    )
    const vh = height * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
}


export const onClientEntry = () => {
    cssVars()
    smoothscroll.polyfill()

    if (typeof window.IntersectionObserver === `undefined`) {
        import(`intersection-observer`)
    }

    window.addEventListener("resize", updateSizing)
    setTimeout(updateSizing, 10)
}
